import { LOCALES } from "../locales";

export default {
  [LOCALES.SPANISH]: {
    "general.language1": "Ingles",
    "general.language2": "Español",
    "general.loading": "Cargando",
    "header.logo": "JM",
    "header.title": "[Tablón de Ofertas: Código de Ejemplo ReactJs + GraphQL]",
    "breadcrumb.menu.option1": "Inicio",
    "breadcrumb.menu.option2": "Detalle de la Oferta: ",
    "footer.api": "API de Ofertas: ",
    "footer.created": "Desarrollado usando:",
    "footer.getcode": "Consigue el código en ",
    "user.hi": "Hola, ",
    "user.guess": "Invitado",
    "user.login": "Ingresar",
    "user.profile": "Mi Cuenta",
    "user.settings": "Ajustes",
    "user.signout": "Cerrar Sesión",
    "user.alt.maybe": "Quizas mas adelante?",
    "user.alt.login": "Presiona para Ingresar",
    "user.alt.signout": "Presiona para Cerrar Sesión",
    "joblist.location": "Ubicación:",
    "joblist.commitment": "Modelo:",
    "joblist.type": "Tipo:",
    "joblist.company": "Empresa:",
    "joblist.date": "Fecha:",
    "jobdetail.nodate":
      "No podemos encontrar la información de esta Oferta. Por favor regrese al Inicio.",
  },
};
